import { useContext } from 'react';
import useCallbackAsync from 'hooks/useCallbackAsync';
import utils from 'utils';
import dataRoomApi from '../dataRoomApi';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

const useDownloadArchiveInstance = () => {
  const { popError } = useContext(PopNotificationsContext);

  const [handleDownload, isDownloading] = useCallbackAsync(
    async (
      archiveId: string,
      archiveInstanceId: string,
      onSucces?: () => void,
    ) => {
      const {
        data: { url, type },
      } = await dataRoomApi.archives.getArchiveInstance(
        archiveId,
        archiveInstanceId,
      );

      if (url) {
        utils.downloadUrl({ type, href: url });
      } else {
        popError();
      }

      onSucces?.();
    },
  );

  return {
    isDownloading,
    handleDownload,
  };
};

export default useDownloadArchiveInstance;
